import Vue from "vue";
import Vuex from "vuex";
import api from "@/components/axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    CartModalShow: false,
    oringModalShow: false,
    cartList: [],
    recentOrder: [],
    order: null,
    invoice: null,
    cargoAddress: null,
    contractAddress: null,
    invoiceAddress: null,
    mrodCartShow: false,
  },
  mutations: {
    storeCartModal(state, data) {
      state.CartModalShow = data;
    },
    storeOringModal(state, data) {
      state.oringModalShow = data;
    },
    storeCartList(state, data) {
      state.cartList = data;
    },
    storeRecentOrder(state, data) {
      state.recentOrder = data;
    },
    storeOrder(state, data) {
      state.order = data;
    },
    storeInvoice(state, data) {
      state.invoice = data;
    },
    storeCargoAddress(state, data) {
      state.cargoAddress = data;
    },
    storeContractAddress(state, data) {
      state.contractAddress = data;
    },
    storeInvoiceAddress(state, data) {
      state.invoiceAddress = data;
    },
    storeMrodCartModal(state, data) {
      state.mrodCartShow = data;
    },
  },
  actions: {
    // 获取购物车数据
    async getCartList({ commit }) {
      const res = await api.get("/order_record/cart");
      if (res.data.code === 200 && res.data.data) {
        const list = res.data.data.filter((x) => x);
        commit("storeCartList", res.data.data);
        window.$cookies.set("orderNums", list.length);
      }
    },
    // 获取订单详情
    async getOrder({ commit }, id) {
      const res = await api.get(`/order_record/${id}`);
      if (res.data.code === 200 && res.data.data) {
        commit("storeOrder", res.data.data);
      }
    },
    // 跳转sso登录
    async toLogin() {
      const url = encodeURIComponent(window.location.href);
      const res = await api.get("/sso/login_url?redirectUrl=" + url);
      if (res.data.code === 200) {
        // 跳转到sso登录页
        window.location.href = res.data.data;
      }
    },
  },
  modules: {},
});
